import constants from '../../config/constants';

// ClickUp 869cydgd4 — "Reembolsar - Datáfono" only makes sense as a refund
// option when the original payment was made with a datáfono (the physical
// POS terminal — DATAFONO — or the connected one — DATAFONO_CONNECTED). Both
// produce a negative-amount payment row with paymentForm = 'DATAFONO', mirror
// of what "Reembolsar - Efectivo" does today for CASH.
export function isDataphonePayment(paymentForm: string | undefined): boolean {
    if (!paymentForm) return false;
    return (
        paymentForm === constants.payment.paymentForms.dataphone.name ||
        paymentForm === constants.payment.paymentForms.dataphoneConnected.name
    );
}
